import React from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';



const PatientChartsTableRow = ({ children, ...props }) => {
	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
		>
			{children}
		</Table.Row>
	);
};


export default PatientChartsTableRow;
